import { Features } from 'mk2/apps/strollers/schemas';
import React from 'react';
import styles from './PlainFeature.mscss';

interface OwnProps {
    features: Features;
    feature: any;
}

type Props = OwnProps;

export class PlainFeature extends React.Component<Props> {
    public render() {
        const { feature, features } = this.props;

        const value = feature.niceValue(features);

        return (
            <div className={styles.PlainFeature}>
                {value}
            </div>
        );
    }
}
